/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Generic_Resource_Types_EndpointInputs */



/**
* | output |
* | --- |
* | "Resource type definitions" |
*
* @param {Scim_Setup_Generic_Resource_Types_EndpointInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_generic_resource_types_endpoint = /** @type {((inputs?: Scim_Setup_Generic_Resource_Types_EndpointInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Generic_Resource_Types_EndpointInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ressourcentyp-Definitionen")
	return /** @type {LocalizedString} */ ("Resource type definitions")
});